import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PaymentComponent from "../../../components/Customer/payments/PaymentComponent";

const PaymentPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    let redirectFinish = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    let redirect = () => {
        navigate('/');
    }

    return <PaymentComponent orderId={ params.orderId }
                             shouldRedirect={ () => redirect() }
                             redirectBack={ (orderId) => redirectBack(orderId) }
                             redirectFinish={ (orderId) => redirectFinish(orderId) }
    />;
}

export default PaymentPage;